<template>
    <div>
        <span>{{ getValue }}</span>
    </div>
</template>

<script>

export default
{
    components: {},
    props: {
        column: {
            type: Object,
        },
        row: {
            type: Object,
        },
    },
    data() {
        return {
        };
    },
    methods: {
    },
    mounted() {
    },
    computed: {
        getValue() {
            return this.row[this.column.data];
        },
    }
}

</script>

<style lang="sass">
</style>


// WEBPACK FOOTER //
// ValueComponent.vue?8ad1d7ee